import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import CountrySelect from "../widgets/input/CountrySelect.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'EditBillingForm',
  setup(__props) {

const form = ref({
  name: "",
  cardNumber: "",
  countryId: null,
  expiration: "",
  cvc: "",
  billingAddress: "",
  billingAddress2: "",
  zipCode: "",
  saveDetails: "",
  countryId2: null,
})

const formatCardNumber = () => {
  let formatted = form.value.cardNumber.replace(/\D/g, "").replace(/(\d{4})(?=\d)/g, "$1 ")
  formatted = formatted.trim()
  form.value.cardNumber = formatted
}

// const formatExpiry = () => {
//   let formatted = form.value.expiration?.replace(/\D/g, "") // Remove non-digit characters

//   if (parseInt(formatted) < 10) {
//     formatted = "0" + formatted
//   }
//   if (formatted.length > 2) {
//     formatted = formatted.substring(0, 2) + "/" + formatted.substring(2)
//   }
//   form.value.expiration = formatted
// }

const formatExpiry = () => {
  const expiration = form.value.expiration
  if (expiration) {
    const digits = expiration.match(/\d/g)

    if (digits) {
      const formatted = digits.map((digit, index) => {
        if (index === 0 && parseInt(digit) >= 2 && parseInt(digit) <= 9) {
          return `0${digit}`
        }
        return digit
      })

      form.value.expiration =
        formatted.slice(0, 2).join("") +
        (formatted.length > 2 ? "/" : "") +
        formatted.slice(2).join("")
    }
  }
}

const onSubmit = () => {
  console.log("onSubmit")
}

return { __sfc: true,form, formatCardNumber, formatExpiry, onSubmit, CountrySelect }
}

})